import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { DataService } from './data.service';
import { TokenService } from './token.service';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class AuthGuardService  {
    constructor(public auth: AuthService, public router: Router, public userCacheService: UserCacheService, private logoutService: TokenService, private dataService: DataService) { }
    canActivate(): boolean {
        if (!this.auth.isAuthenticated()) {
            this.logout();
            return false;
        }
        return true;
    }

    async logout() {
        try {
            await this.logoutService.logout();
            this.userCacheService.eraseAllUserData();
            localStorage.clear();
            this.dataService.userLoggedIn(false);
            window.location.href = '/logout';
        } catch (error) {
            this.userCacheService.eraseAllUserData();
            localStorage.clear();
            this.dataService.userLoggedIn(false);
            window.location.href = '/logout';
        }
    }
}